module.exports = __webpack_public_path__ + "static/media/48.d47d92f7.JPG";